module.exports = __webpack_public_path__ + "img/ahj_edits.c66bf751.png";